import React from "react";
import PageLayout from "../components/PageLayout";

export default function Terms() {
    return (
        <PageLayout
            title="Terms & Conditions for"
            titleHighlight="Pharmacy Wiki"
            subtitle="Last updated: Feb 25, 2025"
            pageTitle="Terms & Conditions"
            showSearch={false}
            showGradient={true}
        >
            <div className="flex flex-col gap-3 mt-8 text-secondary/80 text-14">
                <div>
                    Welcome to Pharmacy.wiki. By accessing or using this Site, you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree to these Terms, please do not use the Site.
                </div>
                <div>
                    Pharmacy.wiki is a free, informational website that provides general information about generic medicines, pharmacy brand names, chemical names, and manufacturer listings. The content provided on this Site is for informational purposes only and is not intended to replace professional medical advice, diagnosis, or treatment. You should always seek the advice of your physician or other qualified healthcare providers regarding any medical condition or treatment.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    1. Acceptance of Terms
                </div>
                <div>
                    By using this Site, you agree that you have read, understood, and accepted these Terms and our Privacy Policy. If you do not agree, please refrain from accessing or using our Site.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    2. No Medical Advice
                </div>
                <div>
                    <ul className="ml-5 list-disc">
                        <li>
                            Informational Purpose Only: The content on Pharmacy.Wiki is intended solely for general informational purposes. It is not intended as, and should not be construed as, professional medical advice, diagnosis, or treatment.
                        </li>
                        <li>
                            Consult a Professional: Always consult with a qualified healthcare provider before making any decisions regarding your health, medications, or treatments.
                        </li>
                        <li>
                            No Liability: Pharmacy.Wiki, its owners, and contributors are not responsible or liable for any outcomes that result from your reliance on the information provided on this Site. Use the information at your own risk.
                        </li>
                    </ul>
                </div>
                <div className="font-semibold text-16 text-secondary">
                    3. Use of Information
                </div>
                <div>
                    <ul className="ml-5 list-disc">
                        <li>
                            Due Diligence: You are solely responsible for verifying any information obtained from the Site before relying on it. We encourage you to conduct your own research and due diligence.
                        </li>
                        <li>
                            Personal Responsibility: Any action you take based on the information on this Site is strictly at your own risk, and Pharmacy.Wiki assumes no liability or responsibility for any errors, omissions, or results obtained from the use of this information.
                        </li>
                    </ul>
                </div>
                <div className="font-semibold text-16 text-secondary">
                    4. Donations and Sponsorship
                </div>
                <div>
                    <ul className="ml-5 list-disc">
                        <li>
                            Donations: Pharmacy.Wiki is a free resource and may accept voluntary donations to help maintain and improve the Site. Donations do not entitle you to any additional rights or influence over the content.
                        </li>
                        <li>
                            Sponsorship and Advertising: We welcome sponsorship and advertising inquiries. If you wish to have your company or products featured on Pharmacy.Wiki, please contact us via email at support@pharmacy.wiki. Any such arrangements will be subject to separate agreements and will not affect the impartiality of our content.
                        </li>
                    </ul>
                </div>
                <div className="font-semibold text-16 text-secondary">
                    5. Intellectual Property
                </div>
                <div>
                    <ul className="ml-5 list-disc">
                        <li>
                            Content Ownership: All content on Pharmacy.Wiki, including text, images, and other materials, is the property of Pharmacy.Wiki or its licensors and is protected by copyright and other intellectual property laws.
                        </li>
                        <li>
                            Limited Use: You may view, download, and print material from this Site for your personal, non-commercial use only. Any other use, including reproduction, distribution, or modification of any part of the Site, is prohibited without prior written consent from Pharmacy.Wiki.
                        </li>
                    </ul>
                </div>
                <div className="font-semibold text-16 text-secondary">
                    6. Third-Party Links
                </div>
                <div>
                    <ul className="ml-5 list-disc">
                        <li>
                            External Websites: Our Site may contain links to third-party websites for additional information or resources. These links are provided for your convenience only, and we do not endorse or have control over the content or practices of these sites.
                        </li>
                        <li>
                            No Liability: Pharmacy.Wiki is not responsible for the privacy practices, content, or any other aspects of third-party websites. Your use of these sites is at your own risk.
                        </li>
                    </ul>
                </div>
                <div className="font-semibold text-16 text-secondary">
                    7. Limitation of Liability
                </div>
                <div>
                    <ul className="ml-5 list-disc">
                        <li>
                            General Disclaimer: In no event shall Pharmacy.Wiki, its owners, authors, or affiliates be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the Site or reliance on its content.
                        </li>
                        <li>
                            No Guarantees: While we strive for accuracy, Pharmacy.Wiki makes no warranties or representations regarding the accuracy, completeness, or reliability of the information provided.
                        </li>
                    </ul>
                </div>
                <div className="font-semibold text-16 text-secondary">
                    8. Indemnification
                </div>
                <div>
                    You agree to indemnify, defend, and hold harmless Pharmacy.Wiki, its owners, officers, employees, agents, and affiliates from and against any and all claims, liabilities, damages, losses, or expenses (including reasonable attorneys' fees) arising out of or in any way connected with your access to or use of the Site or your violation of these Terms.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    9. Modifications to the Terms
                </div>
                <div>
                    Pharmacy.Wiki reserves the right to modify or update these Terms at any time without prior notice. Any changes will be effective immediately upon posting on the Site. Your continued use of the Site after any such modifications constitutes your acceptance of the updated Terms.
                </div>
                <div className="font-semibold text-16 text-secondary">
                    10. Contact Information
                </div>
                <div>
                    If you have any questions or concerns about these Terms or the practices of Pharmacy.Wiki, please contact us at: support@phamarcy.wiki
                </div>
                <hr className="my-4 border-t border-gray-300" />
                <div className="italic">
                    This website and its content are for informational purposes only. Pharmacy.Wiki does not endorse any actions taken based on the information provided on this Site, and you are solely responsible for your own decisions and outcomes. Please consult with appropriate professionals before making any changes to your health regimen or treatment plan.
                </div>
                <div className="italic">
                    By accessing or using Pharmacy.Wiki, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
                </div>
            </div>
        </PageLayout>
    );
}